import { getToken } from '@/libs/util.token'

export default ({ request }) => ({
  purchaseFabricListApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/list',
      method: 'post',
      data,
    })
  },
  purchaseFabricDetailApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/detail',
      method: 'post',
      data,
    })
  },
  purchaseFabricDetailListApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/detail/list',
      method: 'post',
      data,
    })
  },
  purchaseFabricDetailChooseListApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/detail/choose',
      method: 'post',
      data,
    })
  },
  purchaseFabricDetailDetailApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/detail/detail',
      method: 'post',
      data,
    })
  },
  purchaseFabricDetailAddApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/detail/add',
      method: 'post',
      data,
    })
  },
  purchaseFabricDetailEditApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/detail/edit',
      method: 'post',
      data,
    })
  },
  purchaseFabricDetailDelApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/detail/del',
      method: 'post',
      data,
    })
  },
  purchaseFabricExpenseListApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/expense/list',
      method: 'post',
      data,
    })
  },
  purchaseFabricExpenseDetailApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/expense/detail',
      method: 'post',
      data,
    })
  },
  purchaseFabricExpenseAddApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/expense/add',
      method: 'post',
      data,
    })
  },
  purchaseFabricExpenseEditApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/expense/edit',
      method: 'post',
      data,
    })
  },
  purchaseFabricExpenseDelApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/expense/del',
      method: 'post',
      data,
    })
  },
  purchaseFabricBatchListApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/batch/list',
      method: 'post',
      data,
    })
  },
  purchaseFabricBatchDetailApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/batch/detail',
      method: 'post',
      data,
    })
  },
  purchaseFabricBatchAddApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/batch/add',
      method: 'post',
      data,
    })
  },
  purchaseFabricBatchEditApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/batch/edit',
      method: 'post',
      data,
    })
  },
  purchaseFabricBatchDelApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/batch/del',
      method: 'post',
      data,
    })
  },
  purchaseFabricImportDataApi(data = {}) {
    return request({
      url: '/factory/purchase/fabric/importData',
      method: 'post',
      data,
    })
  },
  purchaseFabricWithExcelBatchImportApi({
    file,
    isSave = false,
    isUpdate = false,
  } = {}) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('isSave', isSave)
    formData.append('isUpdate', isUpdate)

    return request({
      url: '/factory/purchase/fabric/withExcelBatchImport',
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: getToken() || '',
      },
      data: formData,
      timeout: 60 * 1000,
    })
  },
})
